import { blobToBase64 } from 'file64';
import {call, put, takeEvery} from 'redux-saga/effects';

import reportApi from '../api/reportApi';
import DeserifyHelper from '../helpers/DeserifyHelper';
import ErrorHelper from '../helpers/errorHelper';
import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';

function* exportActualsCsv(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportActualsCsv, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_ACTUALS_CSV_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_ACTUALS_CSV_FAILED, payload: null});
    }
}

function* exportActualsPdf(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportActualsPdf, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_ACTUALS_PDF_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_ACTUALS_PDF_FAILED, payload: null});
    }
}

function* exportActualsExcel(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportActualsExcel, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_ACTUALS_EXCEL_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_ACTUALS_EXCEL_FAILED, payload: null});
    }
}

function* exportTimesheetsPdf(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportTimesheetsPdf, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_TIMESHEETS_PDF_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_TIMESHEETS_PDF_FAILED, payload: null});
    }
}

function* exportTimesheetsLandscapePdf(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportTimesheetsLandscapePdf, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_TIMESHEETS_LANDSCAPE_PDF_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_TIMESHEETS_LANDSCAPE_PDF_FAILED, payload: null});
    }
}

function* exportTimesheetsWeeklyPdf(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportTimesheetsWeeklyPdf, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_TIMESHEETS_WEEKLY_PDF_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_TIMESHEETS_WEEKLY_PDF_FAILED, payload: null});
    }
}

function* exportTimesheetsWeeklyExcel(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportTimesheetsWeeklyExcel, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_TIMESHEETS_WEEKLY_EXCEL_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_TIMESHEETS_WEEKLY_EXCEL_FAILED, payload: null});
    }
}

function* exportTimesheetsLandscapeExcel(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.exportTimesheetsLandscapeExcel, DeserifyHelper.deserify(action.payload));

        let base64;
        yield blobToBase64(result.blob).then(r => base64 = r);

        yield put({type: ActionTypes.EXPORT_TIMESHEETS_LANDSCAPE_EXCEL_SUCCEEDED, payload: {blob: base64, fileName: result.fileName}});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.EXPORT_TIMESHEETS_LANDSCAPE_EXCEL_FAILED, payload: null});
    }
}

function* postGetTimeLeftOnOrder(action: Action): Generator<any, any, any> {
    try {
        const result = yield call(reportApi.getTimeLeftOnOrder, DeserifyHelper.deserify(action.payload));

        yield put({type: ActionTypes.POST_GET_TIME_LEFT_ON_ORDER_SUCCEEDED, payload: result});
    } catch (e) {
        ErrorHelper.showMessageNoRethrow(e);
        yield put({type: ActionTypes.POST_GET_TIME_LEFT_ON_ORDER_FAILED, payload: null});
    }
}

function* clearTimeLeftOnOrder(): Generator<any, any, any> {
    yield put({type: ActionTypes.CLEAR_TIME_LEFT_ON_ORDER_SUCCEEDED, payload: null});
}

function* reportSaga(): Generator<any, any, any> {
    yield takeEvery(ActionTypes.EXPORT_ACTUALS_CSV_REQUESTED, exportActualsCsv);
    yield takeEvery(ActionTypes.EXPORT_ACTUALS_EXCEL_REQUESTED, exportActualsExcel);
    yield takeEvery(ActionTypes.EXPORT_ACTUALS_PDF_REQUESTED, exportActualsPdf);
    yield takeEvery(ActionTypes.EXPORT_TIMESHEETS_PDF_REQUESTED, exportTimesheetsPdf);
    yield takeEvery(ActionTypes.EXPORT_TIMESHEETS_LANDSCAPE_PDF_REQUESTED, exportTimesheetsLandscapePdf);
    yield takeEvery(ActionTypes.EXPORT_TIMESHEETS_LANDSCAPE_EXCEL_REQUESTED, exportTimesheetsLandscapeExcel);
    yield takeEvery(ActionTypes.EXPORT_TIMESHEETS_WEEKLY_PDF_REQUESTED, exportTimesheetsWeeklyPdf);
    yield takeEvery(ActionTypes.EXPORT_TIMESHEETS_WEEKLY_EXCEL_REQUESTED, exportTimesheetsWeeklyExcel);
    yield takeEvery(ActionTypes.POST_GET_TIME_LEFT_ON_ORDER_REQUESTED, postGetTimeLeftOnOrder);
    yield takeEvery(ActionTypes.CLEAR_TIME_LEFT_ON_ORDER_REQUESTED, clearTimeLeftOnOrder);
}

export default reportSaga;
